import moment from 'moment'
import { Alert, Button, Text } from '@/ui'
import { DATE_FORMATS } from '@/utils/dateHelpers'
import { getFreeTrialEndsAt } from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'
import { useNavigate } from 'react-router-dom'
import { TypographyStyles } from '@/styles'

export const FreeTrialHomepageBanner = () => {
  const trialEndsAt = useReselector(getFreeTrialEndsAt)
  const navigate = useNavigate()
  return (
    <Alert variant="priority">
      <div className="flex flex-col md:flex-row w-full gap-4 items-start md:items-center justify-between">
        <div className="flex-1">
          <Text variant={TypographyStyles.H3}>
            You are previewing the Heard Experience, with{' '}
            {moment(trialEndsAt)
              .startOf('day')
              .diff(moment().startOf('day'), 'days')}{' '}
            days remaining in your trial
          </Text>
          <Text variant={TypographyStyles.BODY_SM}>
            <i>
              Your trial ends on{' '}
              {trialEndsAt
                ? moment(trialEndsAt).format(DATE_FORMATS.DISPLAY_SHORT)
                : ''}
            </i>
          </Text>
        </div>
        <Button
          variant="secondary"
          size="sm"
          className="ml-auto"
          onClick={() => navigate('/accounts/choose-plan')}
        >
          Explore Plans
        </Button>
      </div>
    </Alert>
  )
}
